<template>
    <div class="font-inter p-8">  
      <h1 class="text-2xl font-bold mb-6">User Details</h1>
      <div v-if="loading" class="text-center">Loading...</div>
      <div v-else>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">First Name:</label>
          <input v-if="editMode" v-model="editUser.first_name" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
          <p v-else>{{ user.first_name }}</p>
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Last Name:</label>
          <input v-if="editMode" v-model="editUser.last_name" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
          <p v-else>{{ user.last_name }}</p>
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Email:</label>
          <input v-if="editMode" v-model="editUser.email" type="email" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
          <p v-else>{{ user.email }}</p>
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Phone:</label>
          <input v-if="editMode" v-model="editUser.phone" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
          <p v-else>{{ user.phone }}</p>
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Role:</label>
          <select v-if="editMode" v-model="editUser.role" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
            <option value="user">User</option>
            <option value="talent">Talent</option>
            <option value="manager">Manager</option>
            <option value="admin">Admin</option>
          </select>
          <p v-else>{{ user.role }}</p>
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Superuser:</label>
          <select v-if="editMode" v-model="editUser.is_superuser" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select>
          <p v-else>{{ user.is_superuser ? 'Yes' : 'No' }}</p>
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Date Created:</label>
          <p>{{ new Date(user.date_created).toLocaleString() }}</p>
        </div>
        <div class="flex justify-end space-x-4">
          <button v-if="!editMode" @click="editMode = true" class="py-2 px-4 bg-yellow-500 text-white rounded">Edit</button>
          <button v-if="editMode" @click="updateUser" class="py-2 px-4 bg-green-500 text-white rounded">Save</button>
          <button v-if="editMode" @click="cancelEdit" class="py-2 px-4 bg-gray-500 text-white rounded">Cancel</button>
          <button @click="deleteUser" class="py-2 px-4 bg-red-500 text-white rounded">Delete</button>
          <button @click="goBack" class="py-2 px-4 bg-blue-500 text-white rounded">Back to Users</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import apiClient from '@/axios'
  
  export default {
    name: 'UserDetails',
    data() {
      return {
        user: {},
        editUser: {},
        loading: true,
        editMode: false
      }
    },
    methods: {
      async fetchUserDetails() {
        const userId = this.$route.params.userId
        try {
          const response = await apiClient.get(`/web/users/${userId}`)
          this.user = response.data.data
          this.editUser = { ...response.data.data } // Make a copy for editing
          this.loading = false
        } catch (error) {
          console.error('Error fetching user details:', error)
          this.loading = false
        }
      },
      async updateUser() {
        const userId = this.$route.params.userId
        try {
          const response = await apiClient.put(`/web/users/${userId}`, this.editUser)
          this.user = response.data.data
          this.editMode = false
          console.log('User updated:', response.data.data)
        } catch (error) {
          console.error('Error updating user:', error)
        }
      },
      cancelEdit() {
        this.editUser = { ...this.user } // Revert changes
        this.editMode = false
      },
      async deleteUser() {
        const userId = this.$route.params.userId
        try {
          await apiClient.delete(`/web/users/${userId}`)
          this.$router.push({ name: 'UserList' })
          console.log('User deleted')
        } catch (error) {
          console.error('Error deleting user:', error)
        }
      },
      goBack() {
        this.$router.push({ name: 'UserList' })
      }
    },
    created() {
      this.fetchUserDetails()
    }
  }
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>
  